"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslaitonService = void 0;
var axios_1 = __importDefault(require("axios"));
var queries_1 = require("../components/LanguageSelector/Graphql/queries");
var config_1 = __importDefault(require("../config/config"));
var getLanguages = function (client, country_code) {
    return client
        .query({
        query: queries_1.GET_LANGUAGES,
        variables: {
            country_code: country_code,
        },
        fetchPolicy: "network-only",
        errorPolicy: "all",
    })
        .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.getLanguage) {
                return [2 /*return*/, { data: (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.getLanguage }];
            }
            return [2 /*return*/];
        });
    }); })
        .catch(function (err) {
        console.log({ err: err });
    });
};
var isTranslationObject = function (obj) {
    return typeof obj === "object" && "translation" in obj;
};
var getTranslation = function (storeLang) {
    var res = axios_1.default
        .get("".concat(config_1.default.translation_url, "/api/download/all"), {
        params: {
            productName: "HealthCoach",
            domain: "react",
            country: null,
            language: storeLang || "en",
        },
    })
        .then(function (response) {
        var translatedObject = {};
        Object.entries(response.data).forEach(function (_a) {
            var _b;
            var key = _a[0];
            if (isTranslationObject(response.data[key])) {
                translatedObject = (_b = response.data[key]) === null || _b === void 0 ? void 0 : _b.translation;
                Object.entries(translatedObject).forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    if (v === "") {
                        translatedObject[k] = k;
                    }
                });
            }
        });
        return translatedObject;
    })
        .catch(function (error) { return error; });
    return res;
};
exports.TranslaitonService = {
    getLanguages: getLanguages,
    getTranslation: getTranslation,
};
